import API_BASE_URL from '../config';
import React, { useState, useEffect, useRef } from "react";
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom"; 
import { GLOBAL_CALCULATIONS } from './GlobalLogic';

const Addorder = () => {
    const navigate = useNavigate(); 
    const [articles, setArticles] = useState([]);
    const [allCustomers, setAllCustomers] = useState([]); 
    const [inventory, setInventory] = useState([]); 
    
    // --- CUSTOMER STATES ---
    const [customerName, setCustomerName] = useState("");
    const [isExistingCust, setIsExistingCust] = useState(false);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [filteredCustomers, setFilteredCustomers] = useState([]);
    const dropdownRef = useRef(null);

    // --- ARTICLE STATES (NEW) ---
    const [articleInput, setArticleInput] = useState("");
    const [isExistingArticle, setIsExistingArticle] = useState(false);
    const [showArtSuggestions, setShowArtSuggestions] = useState(false);
    const [filteredArticles, setFilteredArticles] = useState([]);
    const articleRef = useRef(null);

    const [deldays, setDeldays] = useState("");
    const [dateofdelivery, setDateofdelivery] = useState("");
    const [orderDate, setOrderDate] = useState(new Date().toISOString().split('T')[0]);
    const [sellingPriceInput, setSellingPriceInput] = useState(0);
    
    // --- COST STATES ---
    const [fabricCost, setFabricCost] = useState(0);
    const [workCost, setWorkCost] = useState(0);
    const [stitchingCost, setStitchingCost] = useState(0);
    const [lasesCost, setLasesCost] = useState(0);
    const [dupattaCost, setDupattaCost] = useState(0);
    const [extraCostInput, setExtraCostInput] = useState(0);

    // --- MULTI-INVENTORY LINK ---
    const [activeLink, setActiveLink] = useState(null); 
    const [linkedItems, setLinkedItems] = useState({ fabric: [], lases: [], dupatta: [] });
    const [isManual, setIsManual] = useState({
        sellingPrice: false, fabric: false, work: false, stitching: false, lases: false
    });

    const [showFetchedIndicators, setShowFetchedIndicators] = useState(false);
    const [shippingLegs, setShippingLegs] = useState({ to_karigar: 0, to_sufna: 0, to_courier: 0, to_customer: 0 });
    const [instaId, setInstaId] = useState("");
    const [phone, setPhone] = useState("");
    const [odrpart, setOdrpart] = useState("");
    const [odrtrack, setOdrtrack] = useState("");
    const [payrec, setPayrec] = useState(0);  
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        getArticles();
        getCustomers(); 
        getInventory();
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setShowSuggestions(false);
            if (articleRef.current && !articleRef.current.contains(event.target)) setShowArtSuggestions(false);
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // Customer Filtering Logic - UPDATED: Check both Name and Insta ID
    useEffect(() => {
        if (!customerName.trim()) {
            setIsExistingCust(false);
            // toast.success(isExistingCust);
            setFilteredCustomers([]);
            return;
        }

        const normalizedInputName = customerName.toLowerCase().trim();
        const normalizedInputInsta = instaId.replace('@', '').toLowerCase().trim();

        // Exact match logic for the Badge
        const exactMatch = allCustomers.some(c => 
            c.custName.toLowerCase() === normalizedInputName && 
            (c.custInsta || "").replace('@', '').toLowerCase().trim() === normalizedInputInsta
        );
        // console.log(normalizedInputName,normalizedInputInsta);

        setIsExistingCust(exactMatch);
        // console.log(isExistingCust);
        setFilteredCustomers(allCustomers.filter(c => c.custName.toLowerCase().includes(normalizedInputName)));
    }, [customerName, instaId, allCustomers]);

    // Article Filtering Logic
    useEffect(() => {
        if (!articleInput.trim()) {
            setIsExistingArticle(false);
            setFilteredArticles([]);
            return;
        }
        const exactMatch = articles.some(a => a.name.toLowerCase() === articleInput.toLowerCase().trim());
        setIsExistingArticle(exactMatch);
        setFilteredArticles(articles.filter(a => a.name.toLowerCase().includes(articleInput.toLowerCase())));
    }, [articleInput, articles]);

    const getArticles = async () => {
        try {
            let result = await fetch(`${API_BASE_URL}/articleshowa`);
            let data = await result.json();
            if (Array.isArray(data)) setArticles(data);
        } catch (error) { console.error("Error articles:", error); }
    };

    const getCustomers = async () => {
        try {
            let result = await fetch(`${API_BASE_URL}/customershowa`);
            let data = await result.json();
            if (Array.isArray(data)) setAllCustomers(data);
        } catch (error) { console.error("Error customers:", error); }
    };

    const getInventory = async () => {
        try {
            let result = await fetch(`${API_BASE_URL}/inventoryshowa`); 
            let data = await result.json();
            if (Array.isArray(data)) setInventory(data);
        } catch (error) { console.error("Error inventory:", error); }
    };

    const selectCustomer = (cust) => {
        setCustomerName(cust.custName);
        setPhone(cust.custPhone || "");
        setInstaId(cust.custInsta || "");
        setShowSuggestions(false);
    };

    const selectArticle = (art) => {
        setArticleInput(art.name);
        setFabricCost(Number(art.fabric) || 0);
        setWorkCost(Number(art.work) || 0);
        setStitchingCost(Number(art.stiching) || 0);
        setLasesCost(Number(art.misc) || 0); 
        setDupattaCost(Number(art.dupatta) || 0); 
        const totalCost = (Number(art.fabric) || 0) + (Number(art.work) || 0) + (Number(art.stiching) || 0) + (Number(art.misc) || 0);
        setSellingPriceInput(Math.round(totalCost / 0.7));
        setIsManual({ sellingPrice: false, fabric: false, work: false, stitching: false, lases: false });
        setShowFetchedIndicators(true);
        setShowArtSuggestions(false);
    };

    const handleLinkSelect = (type, item, qty) => {
        if (linkedItems[type].length >= 3) {
            alert("Maximum 3 items allowed per category");
            return;
        }
        const newItem = { ...item, used: qty, calculatedCost: item.pricePerUnit * qty };
        setLinkedItems(prev => ({ ...prev, [type]: [...prev[type], newItem] }));
        setActiveLink(null);
    };

    const removeLinkedItem = (type, index) => {
        setLinkedItems(prev => ({ ...prev, [type]: prev[type].filter((_, i) => i !== index) }));
    };

    const getLinkedTotal = (type) => linkedItems[type].reduce((acc, curr) => acc + curr.calculatedCost, 0);

    const handleSubmit = async (event) => {
        event.preventDefault();
        // 1. ADDED: Guard clause to prevent execution if already submitting
        if (isSubmitting) return; 

        // 2. ADDED: Set submitting to true immediately to lock the function
        setIsSubmitting(true);
        const formData = new FormData(event.target);
        const data = Object.fromEntries(formData.entries());
        
        const finalCustName = formatProperCase(customerName);
        const finalInsta = formatInsta(instaId);
        const finalPhone = formatPhone(phone);

        data.custname = finalCustName;
        data.instagramid = finalInsta;
        data.phonenumber = finalPhone;
        data.articlename = articleInput; 
        data.shipping = totalShipping;
        data.shipping_details = shippingLegs;
        
        data.fabric = Number(fabricCost) + getLinkedTotal('fabric');
        data.work = Number(workCost);
        data.stitching = Number(stitchingCost);
        data.lases = Number(lasesCost) + getLinkedTotal('lases');
        data.dupatta = Number(dupattaCost) + getLinkedTotal('dupatta');

        try {
            if (!isExistingCust) {
                const response = await fetch(`${API_BASE_URL}/add-customer`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ custName: finalCustName, custPhone: finalPhone, custInsta: finalInsta, gender: 'Female' })
                });
                if(response.ok){
                toast.success("Customer created successfully");
                console.log("Customer Created");
                }
            }

            if (!isExistingArticle) {
                const response = await fetch(`${API_BASE_URL}/addarticlea`, { 
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        name: articleInput,
                        fabric: fabricCost,
                        work: workCost,
                        stiching: stitchingCost,
                        misc: lasesCost,
                        dupatta: dupattaCost,
                        totalcost: currentTotalCost
                    })
                });
                if(response.ok){
                    toast.success("New Article Created");
                    console.log("New Article Created");
                };
            }

            const response = await fetch(`${API_BASE_URL}/addordera`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }, 
                body: JSON.stringify(data) 
            });

            if (response.ok) {
                const allToDeduct = [...linkedItems.fabric, ...linkedItems.lases, ...linkedItems.dupatta];
                for (const item of allToDeduct) {
                    const updatedStock = item.currentStock - item.used;
                    await fetch(`${API_BASE_URL}/inventoryupdate/${item._id}`, {
                        method: 'PUT',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ 
                            currentStock: updatedStock,
                            logs: [...(item.logs || []), { type: "Removed", quantity: item.used, note: `Used for Order: ${data.custname}` }]
                        })
                    });
                }
                alert(`✅ Order Saved!`); 
                navigate('/orders'); 
            }else{
                setIsSubmitting(false);
                alert("❌ Failed to save order details");
            }
        } catch (error) { 
            // 4. ADDED: Re-enable the button if a network or execution error occurs
            setIsSubmitting(false);
            alert("❌ Server Error"); 
        }
    };

    const formatProperCase = (n) => n ? n.toLowerCase().trim().split(/\s+/).map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ') : "";
    const formatInsta = (v) => v ? v.replace('@', '').toLowerCase().trim() : "";
    const formatPhone = (v) => v.replace(/\D/g, '').slice(-10);

    const totalShipping = Object.values(shippingLegs).reduce((acc, curr) => acc + Number(curr), 0);
    const currentTotalCost = (Number(fabricCost) + getLinkedTotal('fabric')) + Number(workCost) + Number(stitchingCost) + (Number(lasesCost) + getLinkedTotal('lases')) + (Number(dupattaCost) + getLinkedTotal('dupatta')) + Number(extraCostInput);
    const netProfit = Number(sellingPriceInput) - currentTotalCost - totalShipping;
    const customerBalance = Number(sellingPriceInput) - Number(payrec);
    const isCustomerClear = customerBalance <= 0 && Number(sellingPriceInput) > 0;

    const InventoryPicker = ({ type }) => (
        <div className="p-2 border rounded bg-white shadow-sm mt-2 animate__animated animate__fadeIn" style={{zIndex: 10, position: 'absolute', width: '250px'}}>
            <div className="d-flex justify-content-between align-items-center mb-2">
                <small className="fw-bold text-primary">Link {type} ({linkedItems[type].length}/3)</small>
                <button type="button" className="btn-close" style={{fontSize: '10px'}} onClick={() => setActiveLink(null)}></button>
            </div>
            <select className="form-select form-select-sm mb-2" onChange={(e) => {
                const item = inventory.find(i => i._id === e.target.value);
                if (!item) return;
                const qty = prompt(`Enter quantity (${item.unit}) for ${item.itemName}:`, 1);
                if (qty) handleLinkSelect(type, item, Number(qty));
            }}>
                <option value="">Select Item...</option>
                {inventory.map(i => <option key={i._id} value={i._id}>{i.itemName} (Stock: {i.currentStock})</option>)}
            </select>
            <div className="d-flex flex-wrap gap-1">
                {linkedItems[type].map((item, idx) => (
                    <div key={idx} className="badge bg-primary d-flex align-items-center gap-1" style={{fontSize: '9px'}}>{item.itemName.substring(0,8)}.. <i className="bi bi-x-circle cursor-pointer" onClick={() => removeLinkedItem(type, idx)}></i></div>
                ))}
            </div>
        </div>
    );

    const FetchedBadge = ({ field }) => (showFetchedIndicators && !isManual[field]) ? (
        <span className="ms-1" style={{fontSize: '8px', verticalAlign: 'middle', color: '#198754', fontWeight: 'bold'}}>● FETCHED</span>
    ) : null;

    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-11">
                    <h2 className="fw-bold mb-4">Add <span className="text-primary">Order</span></h2>
                    <form id="order-form" onSubmit={handleSubmit}>
                        <div className="row g-4">
                            <div className="col-md-7">
                                <div className="card shadow-sm border-0 h-100 p-4">
                                    <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
                                        <h5 className="fw-bold text-secondary mb-0">👤 Customer & Article</h5>
                                        {customerName.trim() && (
                                            <span className={`badge ${isExistingCust ? 'bg-success-subtle text-success' : 'bg-primary-subtle text-primary'} border fw-bold`} style={{fontSize: '10px'}}>
                                                {isExistingCust ? 'RETURNING CUSTOMER' : 'NEW CUSTOMER'}
                                            </span>
                                        )}
                                    </div>
                                    
                                    <div className="position-relative" ref={dropdownRef}>
                                        <div className="form-floating mb-3">
                                            <input className="form-control bg-light border-0" required placeholder="Name" value={customerName} autoComplete="off" onFocus={() => setShowSuggestions(true)} onChange={(e) => setCustomerName(e.target.value)} />
                                            <label>Customer Name</label>
                                        </div>
                                        {showSuggestions && filteredCustomers.length > 0 && (
                                            <div className="position-absolute w-100 bg-white shadow-lg rounded border p-2 mt-n2" style={{zIndex: 100, maxHeight: '200px', overflowY: 'auto'}}>
                                                {filteredCustomers.map((cust) => (
                                                    <div key={cust._id} className="p-2 cursor-pointer border-bottom d-flex justify-content-between align-items-center" onClick={() => selectCustomer(cust)} style={{cursor: 'pointer'}}>
                                                        <div><div className="fw-bold small">{cust.custName}</div><div className="text-muted" style={{fontSize: '10px'}}>{cust.custPhone}</div></div>
                                                        <i className="bi bi-plus-circle text-primary"></i>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>

                                    <div className="row g-2 mb-3">
                                        <div className="col-6"><div className="form-floating"><input className="form-control bg-light border-0" name="phonenumber" placeholder="Phone" value={phone} onChange={(e) => setPhone(e.target.value)} /><label>Phone</label></div></div>
                                        <div className="col-6"><div className="form-floating"><input className="form-control bg-light border-0" name="instagramid" placeholder="Insta" value={instaId} onChange={(e) => setInstaId(e.target.value)} /><label>Instagram ID</label></div></div>
                                    </div>

                                    <hr />
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h6 className="fw-bold text-muted mb-0">Article Details</h6>
                                        {articleInput.trim() && (
                                            <span className={`badge ${isExistingArticle ? 'bg-success-subtle text-success' : 'bg-warning-subtle text-warning'} border fw-bold`} style={{fontSize: '9px'}}>
                                                {isExistingArticle ? 'REPEATING ARTICLE' : 'NEW ARTICLE'}
                                            </span>
                                        )}
                                    </div>

                                    <div className="row g-2 mb-4">
                                        <div className="col-8 position-relative" ref={articleRef}>
                                            <div className="form-floating">
                                                <input className="form-control bg-light border-0" required placeholder="Article" value={articleInput} autoComplete="off" onFocus={() => setShowArtSuggestions(true)} onChange={(e) => setArticleInput(e.target.value)} />
                                                <label>Article Name</label>
                                            </div>
                                            {showArtSuggestions && filteredArticles.length > 0 && (
                                                <div className="position-absolute w-100 bg-white shadow-lg rounded border p-2 mt-1" style={{zIndex: 100, maxHeight: '200px', overflowY: 'auto'}}>
                                                    {filteredArticles.map((art) => (
                                                        <div key={art._id} className="p-2 cursor-pointer border-bottom d-flex justify-content-between align-items-center" onClick={() => selectArticle(art)} style={{cursor: 'pointer'}}>
                                                            <div className="fw-bold small">{art.name}</div>
                                                            <span className="text-success fw-bold" style={{fontSize: '10px'}}>₹{art.fabric + art.work + art.stiching + (art.misc || 0)}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                        <div className="col-4">
                                            <div className="form-floating">
                                                <input className="form-control border-primary fw-bold text-primary" type="number" name="sellingprice" value={sellingPriceInput} onChange={(e) => {setSellingPriceInput(e.target.value); setIsManual({...isManual, sellingPrice: true});}} required />
                                                <label>Selling Price <FetchedBadge field="sellingPrice" /></label>
                                            </div>
                                        </div>
                                    </div>

                                    <h6 className="fw-bold text-muted mb-3"><i className="bi bi-currency-dollar"></i> Production Costs</h6>
                                    <div className="row g-2 mb-3">
                                        <div className="col-4">
                                            <div className="form-floating position-relative">
                                                <input className={`form-control border-0 ${linkedItems.fabric.length > 0 ? 'bg-primary-subtle' : 'bg-light'}`} type="number" value={fabricCost} onChange={(e)=>{setFabricCost(e.target.value); setIsManual({...isManual, fabric: true});}} />
                                                <label>Fabric {linkedItems.fabric.length > 0 && `(+₹${getLinkedTotal('fabric')})`}</label>
                                                <button type="button" onClick={() => setActiveLink(activeLink === 'fabric' ? null : 'fabric')} className="btn btn-sm btn-link position-absolute top-0 end-0 mt-1 me-1 text-decoration-none" style={{fontSize: '10px'}}>{linkedItems.fabric.length > 0 ? 'ADD' : 'LINK'}</button>
                                            </div>
                                            {activeLink === 'fabric' && <InventoryPicker type="fabric" />}
                                        </div>
                                        <div className="col-4"><div className="form-floating"><input className="form-control bg-light border-0" type="number" value={workCost} onChange={(e)=>{setWorkCost(e.target.value); setIsManual({...isManual, work: true});}} /><label>Work <FetchedBadge field="work" /></label></div></div>
                                        <div className="col-4"><div className="form-floating"><input className="form-control bg-light border-0" type="number" value={stitchingCost} onChange={(e)=>{setStitchingCost(e.target.value); setIsManual({...isManual, stitching: true});}} /><label>Stitching <FetchedBadge field="stitching" /></label></div></div>
                                        <div className="col-4">
                                            <div className="form-floating position-relative">
                                                <input className={`form-control border-0 ${linkedItems.lases.length > 0 ? 'bg-primary-subtle' : 'bg-light'}`} type="number" value={lasesCost} onChange={(e)=>{setLasesCost(e.target.value); setIsManual({...isManual, lases: true});}} />
                                                <label>Lases {linkedItems.lases.length > 0 && `(+₹${getLinkedTotal('lases')})`}</label>
                                                <button type="button" onClick={() => setActiveLink(activeLink === 'lases' ? null : 'lases')} className="btn btn-sm btn-link position-absolute top-0 end-0 mt-1 me-1 text-decoration-none" style={{fontSize: '10px'}}>{linkedItems.lases.length > 0 ? 'ADD' : 'LINK'}</button>
                                            </div>
                                            {activeLink === 'lases' && <InventoryPicker type="lases" />}
                                        </div>
                                        <div className="col-4">
                                            <div className="form-floating position-relative">
                                                <input className={`form-control border-0 ${linkedItems.dupatta.length > 0 ? 'bg-primary-subtle' : 'bg-light'}`} type="number" value={dupattaCost} onChange={(e)=>setDupattaCost(e.target.value)} />
                                                <label>Dupatta {linkedItems.dupatta.length > 0 && `(+₹${getLinkedTotal('dupatta')})`}</label>
                                                <button type="button" onClick={() => setActiveLink(activeLink === 'dupatta' ? null : 'dupatta')} className="btn btn-sm btn-link position-absolute top-0 end-0 mt-1 me-1 text-decoration-none" style={{fontSize: '10px'}}>{linkedItems.dupatta.length > 0 ? 'ADD' : 'LINK'}</button>
                                            </div>
                                            {activeLink === 'dupatta' && <InventoryPicker type="dupatta" />}
                                        </div>
                                        <div className="col-4"><div className="form-floating"><input className="form-control bg-light border-0" type="number" name="extracost" value={extraCostInput} onChange={(e) => setExtraCostInput(e.target.value)}/><label>Extra Cost</label></div></div>
                                    </div>

                                    <div className="row g-2 text-center mt-2">
                                        <div className="col-6"><div className="p-2 border rounded bg-light"><small className="text-muted d-block small fw-bold">Total Production Cost</small><span className="fw-bold">₹{currentTotalCost}</span></div></div>
                                        <div className="col-6"><div className={`p-2 border rounded bg-light ${netProfit >= 0 ? 'border-success' : 'border-danger'}`}><small className={`${netProfit >= 0 ? 'text-success' : 'text-danger'} d-block small fw-bold`}>Net Profit</small><span className={`fw-bold ${netProfit >= 0 ? 'text-success' : 'text-danger'}`}>₹{netProfit}</span></div></div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-5">
                                <div className="card shadow-sm border-0 h-100 p-4">
                                    <h5 className="fw-bold text-secondary mb-3 border-bottom pb-2">📅 Logistics</h5>
                                    <div className="form-floating mb-3"><input className="form-control bg-light border-0" type="date" name="dateoforder" value={orderDate} onChange={(e) => setOrderDate(e.target.value)} required /><label>Order Date</label></div>
                                    <div className="row g-2 mb-3">
                                        <div className="col-8"><div className="form-floating"><input className="form-control bg-light border-0" type="date" name="dateofdelivery" value={dateofdelivery} onChange={(e) => { setDateofdelivery(e.target.value); setDeldays(GLOBAL_CALCULATIONS.getDaysFromDate(e.target.value)); }} required /><label>Delivery Date</label></div></div>
                                        <div className="col-4"><div className="form-floating"><input className="form-control border-primary fw-bold" type="number" name="deldays" value={deldays} onChange={(e) => { setDeldays(e.target.value); setDateofdelivery(GLOBAL_CALCULATIONS.getDateFromDays(e.target.value)); }} /><label className="text-primary">Days</label></div></div>
                                    </div>
                                    {/* <div className="mb-3">
                                        <label className="small fw-bold text-muted text-uppercase mb-1" style={{fontSize: '9px'}}>Shipping Breakdown (₹{totalShipping})</label>
                                        <div className="input-group shadow-sm border rounded overflow-hidden">
                                            <input type="number" className="form-control border-0 text-center border-end" name="to_karigar" value={shippingLegs.to_karigar} onChange={(e) => setShippingLegs({...shippingLegs, [e.target.name]: e.target.value})} />
                                            <input type="number" className="form-control border-0 text-center border-end" name="to_sufna" value={shippingLegs.to_sufna} onChange={(e) => setShippingLegs({...shippingLegs, [e.target.name]: e.target.value})} />
                                            <input type="number" className="form-control border-0 text-center border-end" name="to_courier" value={shippingLegs.to_courier} onChange={(e) => setShippingLegs({...shippingLegs, [e.target.name]: e.target.value})} />
                                            <input type="number" className="form-control border-0 text-center fw-bold text-primary bg-white" name="to_customer" value={shippingLegs.to_customer} onChange={(e) => setShippingLegs({...shippingLegs, [e.target.name]: e.target.value})} />
                                        </div>
                                    </div> */}
                                    {/* <div className="row g-2 mb-3">
                                        <div className="col-6"><div className="form-floating"><select className="form-select bg-light border-0" name="odrpart" value={odrpart} onChange={(e) => setOdrpart(e.target.value)}><option value="">None</option>{["Delhivery", "BlueDart", "DTDC", "India Post"].map(p => <option key={p} value={p}>{p}</option>)}</select><label>Partner</label></div></div>
                                        <div className="col-6"><div className="form-floating"><input className="form-control bg-light border-0" name="odrtrack" placeholder="Tracking ID" value={odrtrack} onChange={(e) => setOdrtrack(e.target.value)} disabled={!odrpart} /><label>Tracking ID</label></div></div>
                                    </div> */}
                                    <div className="form-floating"><select className="form-select bg-light border-0 fw-bold text-primary" name="odrsts"><option>Order Confirmed</option><option>Fabric Recieved</option><option>Embroidery</option><option>Stiching</option><option>Ready To Ship</option><option>Delivered</option></select><label>Current Status</label></div>
                                </div>
                            </div>

                            <div className="col-12">
                                <div className="card shadow-sm border-0 p-4 bg-white">
                                    <h5 className="fw-bold text-secondary mb-3 border-bottom pb-2">💰 Payment Tracking</h5>
                                    <div className="row g-3 align-items-center">
                                        <div className="col-md-4"><div className="form-floating"><input className="form-control border-0 bg-light" type="number" name="payrec" value={payrec} onChange={(e) => setPayrec(e.target.value)} max={sellingPriceInput} /><label>Payment Recieved</label></div></div>
                                        <div className="col-md-4"><div className="form-switch p-3 border rounded bg-light h-100 d-flex align-items-center justify-content-center"><input className="form-check-input me-2" type="checkbox" checked={Number(sellingPriceInput) > 0 && Number(sellingPriceInput) === Number(payrec)} onChange={(e) => setPayrec(e.target.checked ? sellingPriceInput : 0)} /><label className="form-check-label fw-bold text-secondary">Full Paid?</label></div></div>
                                        <div className="col-md-4"><div className={`h-100 d-flex flex-column justify-content-center align-items-center rounded-3 p-3 border ${isCustomerClear ? 'bg-success text-white' : 'bg-white border-warning text-warning'}`}><small className="fw-bold" style={{fontSize: '10px'}}>STATUS</small><span className="fw-bold">{isCustomerClear ? "DONE" : `Due: ₹${customerBalance}`}</span></div></div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12">
                                <div className="card shadow-sm border-0 p-4">
                                    <div className="form-floating mb-3"><textarea className="form-control bg-light border-0" style={{height: "80px"}} name="odrint" placeholder="Instructions"></textarea><label>Instructions</label></div>
                                    <div className="d-flex justify-content-end gap-2">
                                        <button type="button" className="btn btn-outline-secondary px-5 py-2 fw-bold" onClick={() => navigate('/orders')}>Cancel</button>
                                        <button type="submit" disabled = {isSubmitting} className="btn btn-primary px-5 py-2 fw-bold shadow">{isSubmitting ? 'Saving Order...' : 'Save Final Order'}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Addorder;
